import Constants from "expo-constants";
import { Platform } from "react-native";
import { logger } from "../lib/logger";

const FATHOM_SITE_ID = process.env.EXPO_PUBLIC_FATHOM_SITE_ID;

const FATHOM_INCLUDED_DOMAIN_PRODUCTION = "app.openstudiojazz.com";
const FATHOM_INCLUDED_DOMAIN_STAGING = "josephine-env-staging-open-studio.vercel.app";

declare global {
  interface Window {
    fathom?: {
      trackPageview: (opts?: { url?: string; referrer?: string }) => void;
      trackEvent: (name: string, opts?: { _value?: number }) => void;
    };
  }
}

class FathomService {
  private isInitialized = false;

  initialize(): void {
    if (Platform.OS !== "web" || typeof document === "undefined" || this.isInitialized) {
      return;
    }

    if (!FATHOM_SITE_ID?.trim()) {
      __DEV__ && logger.debug("Fathom site ID not set; skipping Fathom.");
      return;
    }

    if (document.getElementById("fathom-script")) {
      this.isInitialized = true;
      return;
    }

    try {
      const script = document.createElement("script");
      script.id = "fathom-script";
      script.defer = true;
      script.src = "https://cdn.usefathom.com/script.js";
      script.setAttribute("data-site", FATHOM_SITE_ID.trim());
      script.setAttribute("data-spa", "auto");
      const variant = Constants.expoConfig?.extra?.appVariant;
      const included =
        variant === "production"
          ? FATHOM_INCLUDED_DOMAIN_PRODUCTION
          : variant === "staging"
            ? FATHOM_INCLUDED_DOMAIN_STAGING
            : undefined;
      if (included) {
        script.setAttribute("data-included-domains", included);
      }
      document.head.appendChild(script);
      this.isInitialized = true;
    } catch (error) {
      logger.error("Fathom init failed:", error);
    }
  }
}

export const fathomService = new FathomService();
